import { CloseOutlined } from "@ant-design/icons"
import { Button, Drawer, Flex, Space, Spin, Typography } from "antd"
import React from "react"

interface ContractEditPreviewHTMLProps {
  html: string
  saving: boolean
  onClose: () => void
  onClickGenerate: () => void
  onClickConfirm: () => void
}

export function ContractEditPreviewHTML({
  html,
  saving,
  onClose,
  onClickGenerate,
  onClickConfirm
}: ContractEditPreviewHTMLProps) {
  return (
    <Drawer
      classNames={{ body: "p-1" }}
      open
      width="100VW"
      title={"Contract Preview"}
      onClose={onClose}
    >
      {saving && <Spin fullscreen />}
      <Flex vertical gap={"small"} className={"size-full"}>
        <iframe
          srcDoc={html}
          className="flex-1 border-0"
          sandbox="allow-same-origin"
          title="Preview"
        />
        <Flex justify={"space-between"} className={"p-2"}>
          <Button disabled={saving} onClick={onClose} danger>
            Cancel
          </Button>
          <Space>
            <Button
              disabled={saving}
              onClick={onClickGenerate}
              type={"primary"}
            >
              Generate
            </Button>
            <Button disabled={saving} onClick={onClickConfirm} type={"primary"}>
              Submit
            </Button>
          </Space>
        </Flex>
      </Flex>
    </Drawer>
  )
}
